// @flow

import React from 'react'
import { withRouter } from 'react-router'
import { Route, Switch, Redirect } from 'react-router-dom'
import type { RouterHistory } from 'react-router'
import clientData from 'utils/client-data'
import {
  init as initSessionTimer,
  onSessionExtended,
} from 'utils/session-timer'
import _ from 'lodash'

import {
  AnimatedSwitchPagination,
  SimpleLayout,
  SessionTimer,
  MainComponent,
  ProfileDetails,
  // CreateProfile,
  SlugProfile,
  Grab,
  Taken,
  Success,
  Picture,
  SettingsContainer,
  MyProfileSettings,
  TurnOffConfirmation,
  PersonalMessage,
  Location,
  CoverPhoto,
  ProfileReview,
  LandingPage,
  CreateForExistingUser,
  Preference,
  GrabLandingPage,
} from './async-loading'

import ErrorScreen from './screens/error'
import { isValidNumber } from './screens/recipient-slug/extract-amount-info'

const CompProfileView = _.get(
  clientData,
  'recipientSlugDetails.slugDetails.isProfileStatusActive',
)
  ? MainComponent
  : SimpleLayout

const overpanelViews = [
  'picture',
  'grab',
  'settings',
  'taken',
  'error',
  'success',
  'location',
  'cover',
  'status',
  'confirm',
  'personalmessage',
  'review',
  'welcome',
  'profile',
  'create',
  'preference',
  'landing',
  'session-timeout',
]

type AppProps = {
  history: RouterHistory,
}

class App extends React.Component<AppProps> {
  componentDidMount() {
    initSessionTimer({
      onWarning: () => this.props.history.push('/my/session-timeout'),
    })
  }
  handleSessionExtension = () => {
    onSessionExtended()
    this.props.history.goBack()
  }
  render() {
    return (
      <div>
        <Switch>
          {/* ANIMATED ROUTING WITHIN OVERPANEL DESIGN */}
          <Route exact path={`/my/(${overpanelViews.join('|')})`}>
            <SimpleLayout>
              <AnimatedSwitchPagination>
                {/* GRAB */}
                <GrabRoute exact path="/my/grab" component={Grab} />
                <GrabRoute exact path="/my/success" component={Success} />
                <GrabRoute exact path="/my/picture" component={Picture} />
                <GrabRoute exact path="/my/taken" component={Taken} />
                <GrabRoute
                  exact
                  path="/my/landing"
                  component={GrabLandingPage}
                />
                <GrabRoute
                  exact
                  path="/my/create"
                  component={CreateForExistingUser}
                />

                {/* SETTINGS */}
                <SettingsRoute
                  exact
                  path="/my/welcome"
                  component={LandingPage}
                />
                <SettingsRoute
                  exact
                  path="/my/settings"
                  component={MyProfileSettings}
                />
                <SettingsRoute
                  exact
                  path="/my/confirm"
                  component={TurnOffConfirmation}
                />
                <SettingsRoute
                  exact
                  path="/my/personalmessage"
                  component={PersonalMessage}
                />
                <SettingsRoute exact path="/my/location" component={Location} />
                <SettingsRoute exact path="/my/cover" component={CoverPhoto} />
                <SettingsRoute
                  exact
                  path="/my/review"
                  component={ProfileReview}
                />
                <SettingsRoute
                  exact
                  path="/my/profile"
                  component={ProfileDetails}
                />
                <SettingsRoute
                  exact
                  path="/my/preference"
                  component={Preference}
                />

                {/* GENERAL */}
                <Route
                  exact
                  path="/my/session-timeout"
                  render={props => (
                    <SessionTimer
                      onSessionExtended={this.handleSessionExtension}
                      {...props}
                    />
                  )}
                />

                {/* ERROR */}
                <Route exact path="/my/error" component={ErrorScreen} />

                {/* UNMATCHED CATCH-ALL ROUTES */}
                <Route path="/my">
                  <Redirect to="/my/profile" />
                </Route>
                <Route path="/grab">
                  <Redirect to="/my/grab" />
                </Route>
              </AnimatedSwitchPagination>
            </SimpleLayout>
          </Route>

          <Route
            exact
            path={'/:slug(\\w{2,20})/:amountInfo?'}
            render={props =>
              isValidNumber(props.match.params.amountInfo) ? (
                <CompProfileView>
                  <SlugProfile {...props} />
                </CompProfileView>
              ) : (
                <SimpleLayout>
                  <SlugProfile {...props} />
                </SimpleLayout>
              )
            }
          />
          <Redirect to="/" />
        </Switch>
      </div>
    )
  }
}

type ReactComponent = () => React.Element | React.Component

function SettingsRoute({
  component: Comp,
  ...props
}: {
  component: ReactComponent,
}) {
  return (
    <Route
      exact
      render={routerProps => (
        <SettingsContainer {...routerProps} body={<Comp {...routerProps} />} />
      )}
      {...props}
    />
  )
}

function GrabRoute({ component: Comp }: { component: ReactComponent }) {
  return <Route exact render={routerProps => <Comp {...routerProps} />} />
}

export default withRouter(App)
